import React from "react";

const ApplicationSuccess = ({
  isApplicationSuccessOpen,
  closeApplicationSuccess,
  loanProductName,
  amount,
  handleContinueCreateLoan,
}) => {
  if (!isApplicationSuccessOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
      <div className="bg-white rounded-sm shadow-xl w-[670px] h-[340px] flex flex-col items-center justify-center p-8 text-center">
        <div className="mb-6 flex items-center justify-center w-[76px] h-[76px] rounded-full bg-blue-100">
          <div className="bg-blue-100 p-3 rounded-full">
            <img
              src="/blue-tick.png"
              alt="Awaiting Approval"
              className="w-12 h-12"
            />
          </div>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          Loan Application Successful!''
        </h2>

        <p className="text-gray-600 text-sm mb-8 max-w-[420px] leading-relaxed">
          The loan has been approved and is now ready for
          <br />
          disbursement to the member
        </p>

        <div className="flex justify-center items-center mt-6">
          <button
            className="border border-[#074073] text-[14px] text-[#074073] w-[211px] h-[49px] rounded-md font-medium whitespace-nowrap hover:bg-[#074073] hover:text-white transition-colors duration-200"
            onClick={closeApplicationSuccess}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSuccess;
